import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';
import { NotificationService } from '../../api/services/notification.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-notifications-preferences',
  templateUrl: './notifications-preferences.component.html',
  styleUrls: ['./notifications-preferences.component.scss']
})

export class NotificationsPreferencesComponent implements OnInit {

  showWarningMessage = false;
  customNotificationPreferences = [];
  loading = true;
  loadingPrefDetails: boolean = false;
  constructor(private authService: AuthService,
    private notificationService: NotificationService,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService
  ) { }


  ngOnInit() {
    this.loading = true;
    this.notificationService.getCustomUserPreferences(this.authService.getUserId())
      .subscribe(prefs => {
        this.customNotificationPreferences = prefs;
        this.loading = false;
      });
  }

  save() {
    this.loadingPrefDetails = true;
    this.notificationService.saveCustomPreference(this.authService.getUserId(), this.customNotificationPreferences).subscribe(data => {
        this.activeModal.close();
        this.loadingPrefDetails = false;
        this.onUpdateSuccess();
      }, error => {
        this.loadingPrefDetails = false;
        this.activeModal.close();
        this.onUpdateFailure();
      });
  }

  checkValue(pref, key) {
    return pref[key];
  }

  updateCustomPref(i, pref, key) {
    if (key === 'immediate') {
      this.customNotificationPreferences[i]['noNotification'] = false;
      this.customNotificationPreferences[i]['digest'] = false;
    } else if (key === 'noNotification') {
      this.customNotificationPreferences[i]['immediate'] = false;
      this.customNotificationPreferences[i]['digest'] = false;
    } else {
      this.customNotificationPreferences[i]['noNotification'] = false;
      this.customNotificationPreferences[i]['immediate'] = false;
    }
    this.customNotificationPreferences[i][key] = true;
  }

  private onUpdateSuccess() {
    this.toastr.success('Notification Preference saved successfully!!!', 'OK!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateFailure() {
    this.toastr.error('Failed to save notification preference!!!', 'Error!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/notifications-preferences/notifications-preferences.component.ts